/**
 * Cookie Consent Region Detection
 *
 * Maps country codes to consent regions for GDPR/LGPD compliance.
 */export enum CookieConsentRegion{EU='EU',// European Union - GDPR
UK='UK',// United Kingdom - PECR
BR='BR',// Brazil - LGPD
ROW='ROW'// Rest of World - no specific requirements
,}/**
 * EU member state country codes (ISO 3166-1 alpha-2).
 * These countries are subject to GDPR.
 */const EU_COUNTRIES=new Set(['AT',// Austria
'BE',// Belgium
'BG',// Bulgaria
'HR',// Croatia
'CY',// Cyprus
'CZ',// Czech Republic
'DK',// Denmark
'EE',// Estonia
'FI',// Finland
'FR',// France
'DE',// Germany
'GR',// Greece
'HU',// Hungary
'IE',// Ireland
'IT',// Italy
'LV',// Latvia
'LT',// Lithuania
'LU',// Luxembourg
'MT',// Malta
'NL',// Netherlands
'PL',// Poland
'PT',// Portugal
'RO',// Romania
'SK',// Slovakia
'SI',// Slovenia
'ES',// Spain
'SE'// Sweden
]);/**
 * Map a country code to a cookie consent region.
 *
 * @param countryCode - ISO 3166-1 alpha-2 country code (e.g., 'US', 'DE')
 * @returns The consent region for the country
 */export function countryCodeToRegion(countryCode:string|null):CookieConsentRegion{if(!countryCode)return CookieConsentRegion.ROW;const code=countryCode.toUpperCase();if(code==='GB')return CookieConsentRegion.UK;if(code==='BR')return CookieConsentRegion.BR;if(EU_COUNTRIES.has(code))return CookieConsentRegion.EU;return CookieConsentRegion.ROW;}/**
 * Check if a region requires explicit cookie consent.
 *
 * @param region - The consent region to check
 * @returns true — all regions now require cookie consent
 */export function requiresCookieConsent(_region:CookieConsentRegion):boolean{return true;}